import { Rang, TabDescriptor, OperationBCI, StatusId } from '../types';

// Logique PURE des onglets acheteur-BCI. Modele BCI : UNE seule commande par operation
// (rang 1 ou 2), pas de cascade. Deux onglets : Consultation + Offre, bases sur l'unique
// commande. Aucune dependance React.

const parseRang = (value: string | number | undefined): Rang => {
  const n = parseInt(String(value ?? 1), 10);
  return (n === 2 || n === 3 ? n : 1) as Rang;
};

const offreHasArticles = (operation: OperationBCI): boolean =>
  ((operation.commandes?.[0]?.articles?.length ?? 0) > 0);

// Statuts ou une offre est a traiter cote acheteur (offre recue / decision en cours / figee).
const OFFRE_STATUSES: number[] = [
  StatusId.AAccepter,
  StatusId.PropositionFaite,
  StatusId.AAnalyser,
  StatusId.Valide,
  StatusId.Refuse,
  StatusId.Expire,
];

export const buildOperationTabs = (operation: OperationBCI): TabDescriptor[] => {
  const commande = operation.commandes?.[0];
  const rang = parseRang(commande?.rang);
  const isBrouillon = operation.status?.id === StatusId.BrouillonAcheteur;

  // Offre desactivee tant que l'operation est en brouillon ou que la commande n'a pas d'articles.
  const offreDisabled = isBrouillon || !offreHasArticles(operation);

  return [
    {
      key: `consultation-${rang}`,
      kind: 'consultation',
      rang,
      label: `Consultation Rang ${rang}`,
      disabled: false,
      inactive: false,
    },
    {
      key: `offre-${rang}`,
      kind: 'offre',
      rang,
      label: `Offre Rang ${rang}`,
      disabled: offreDisabled,
      inactive: false,
    },
  ];
};

// Onglet actif par defaut (hors URL ?tab) : Offre s'il y a une offre a traiter et qu'elle est
// accessible ; sinon Consultation.
export const computeDefaultTabIndex = (
  descriptors: TabDescriptor[],
  operation: OperationBCI,
): number => {
  const statusId = operation.status?.id;
  const offreToTreat =
    offreHasArticles(operation) || (statusId !== undefined && OFFRE_STATUSES.includes(statusId));

  if (statusId !== StatusId.BrouillonAcheteur && offreToTreat) {
    const i = descriptors.findIndex((d) => d.kind === 'offre');
    if (i !== -1 && !descriptors[i].disabled) return i;
  }
  return 0;
};
